import { ApiCommunications, NullPromise } from '../../webmodule-common/interop/webmodule-interop';

import { LanguageResourceData } from '../../localization/language-item-data';
import { LangApi } from './lang-api';

export class LangApiImplementation implements LangApi {
  api: ApiCommunications;

  constructor(api: ApiCommunications) {
    this.api = api;
  }

  public async getV6DbLangFile(supplierId: string, buildVersion: string): NullPromise<LanguageResourceData[]> {
    return await this.api.get<LanguageResourceData[]>(
      `api/Lang/v6/${supplierId}/${buildVersion}/lang.json`,
      true,
      true
    );
  }

  public async getFrameConfigLangFile(buildVersion: string): NullPromise<LanguageResourceData[]> {
    return await this.api.get<LanguageResourceData[]>(`api/Lang/v6/frameconfig/${buildVersion}/lang.json`, true, true);
  }
}
